import React from 'react';

import { Card, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch, StatusFilterSelect } from 'common/components';

const Filters = ({
    filterData,
    handleOnChangeSearch,
    handleOnSelectStatus,
}) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="end" justifyContent="flex-end">
                    <Grid
                        size={{
                            md: 12,
                            xs: 18,
                        }}
                    >
                        <InputSearch
                            onChange={handleOnChangeSearch}
                            placeholder={t('Search')}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid size={{ md: 6, xs: 18 }}>
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={handleOnSelectStatus}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Card.Body>
        </Card>
    );
};

Filters.propTypes = {
    filterData: PropTypes.object,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
};

export default Filters;
